// extracted by mini-css-extract-plugin
export default {"familyDivider":"styles_familyDivider__lwBGC","familySubtitle":"styles_familySubtitle__LU-dD"};